var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestCompleteModalImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 249,
    height: 142,
    viewBox: "0 0 249 142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1",
    "data-name": "\\u9577\\u65B9\\u5F62 1",
    width: 249,
    height: 142,
    transform: "translate(-0.263 -0.196)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illust01",
    transform: "translate(0.263 0.196)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_5",
    "data-name": "\\u30D1\\u30B9 5",
    d: "M77.873,30.142a17.388,17.388,0,1,0-17.39,17.378,17.385,17.385,0,0,0,17.39-17.378",
    transform: "translate(30.159 8.931)",
    fill: "#e97e42"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_1",
    "data-name": "\\u6955\\u5186\\u5F62 1",
    cx: 17.388,
    cy: 17.378,
    rx: 17.388,
    ry: 17.378,
    transform: "translate(73.255 21.695)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_6",
    "data-name": "\\u30D1\\u30B9 6",
    d: "M77.873,30.142a17.388,17.388,0,1,0-17.39,17.378,17.385,17.385,0,0,0,17.39-17.378",
    transform: "translate(30.159 8.931)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_2",
    "data-name": "\\u6955\\u5186\\u5F62 2",
    cx: 17.388,
    cy: 17.378,
    rx: 17.388,
    ry: 17.378,
    transform: "translate(73.255 21.695)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_7",
    "data-name": "\\u30D1\\u30B9 7",
    d: "M117.612,30.142a17.388,17.388,0,1,0-17.388,17.378,17.383,17.383,0,0,0,17.388-17.378",
    transform: "translate(57.946 8.931)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_3",
    "data-name": "\\u6955\\u5186\\u5F62 3",
    cx: 17.388,
    cy: 17.378,
    rx: 17.388,
    ry: 17.378,
    transform: "translate(140.782 21.695)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_8",
    "data-name": "\\u30D1\\u30B9 8",
    d: "M5.447,87.413H242.9a5.161,5.161,0,1,0,0-10.322H5.447a5.161,5.161,0,1,0,0,10.322",
    transform: "translate(0.222 53.849)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9",
    "data-name": "\\u30D1\\u30B9 9",
    d: "M5.447,87.413H242.9a5.161,5.161,0,1,0,0-10.322H5.447a5.161,5.161,0,1,0,0,10.322Z",
    transform: "translate(0.222 53.849)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10",
    "data-name": "\\u30D1\\u30B9 10",
    d: "M106.466,23.466c-2.211.105-5.266-2.07-6.856-3.821a1.354,1.354,0,0,0-2.078,1.734L99.4,23.807l-8.892.279A1.258,1.258,0,0,0,89.287,25.4l.01.245a1.261,1.261,0,0,0,1.213,1.2l7.842.275-8.88.691a1.259,1.259,0,0,0-1.15,1.418l0,.025a1.262,1.262,0,0,0,1.247,1.1l8.9.019-8.409.893a1.257,1.257,0,0,0-1.1,1.525l0,.017a1.257,1.257,0,0,0,1.266.983l8.576-.258-5.641,1.08a1.259,1.259,0,0,0,.4,2.485c2.816-.37,10.426-1.343,13.923-1.53Z",
    transform: "translate(61.774 13.425)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11",
    "data-name": "\\u30D1\\u30B9 11",
    d: "M106.466,23.466c-2.211.105-5.266-2.07-6.856-3.821a1.354,1.354,0,0,0-2.078,1.734L99.4,23.807l-8.892.279A1.258,1.258,0,0,0,89.287,25.4l.01.245a1.261,1.261,0,0,0,1.213,1.2l7.842.275-8.88.691a1.259,1.259,0,0,0-1.15,1.418l0,.025a1.262,1.262,0,0,0,1.247,1.1l8.9.019-8.409.893a1.257,1.257,0,0,0-1.1,1.525l0,.017a1.257,1.257,0,0,0,1.266.983l8.576-.258-5.641,1.08a1.259,1.259,0,0,0,.4,2.485c2.816-.37,10.426-1.343,13.923-1.53Z",
    transform: "translate(61.774 13.425)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_12",
    "data-name": "\\u30D1\\u30B9 12",
    d: "M133.09,14.261a32.691,32.691,0,0,1-12.127,9.532C113.576,27.2,99,26.915,99,26.915l1.025,12.1c22.037-.18,35.157-4.456,41.721-13.3",
    transform: "translate(69.245 9.976)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13",
    "data-name": "\\u30D1\\u30B9 13",
    d: "M133.09,14.261a32.691,32.691,0,0,1-12.127,9.532C113.576,27.2,99,26.915,99,26.915l1.025,12.1c22.037-.18,35.157-4.456,41.721-13.3",
    transform: "translate(69.245 9.976)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_14",
    "data-name": "\\u30D1\\u30B9 14",
    d: "M106.316,60.283V30.7a18.873,18.873,0,0,1,18.822-18.812h.426A17.7,17.7,0,0,1,142.9,26.872a13.747,13.747,0,0,0,4.294,8.106c3.869,3.266,4.566,5.136,5.3,9.313.568,3.208,1.777,5.862,6.347,6.749a4.668,4.668,0,0,1-.938,9.242Z",
    transform: "translate(74.364 8.317)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    "data-name": "\\u30D1\\u30B9 15",
    d: "M106.316,60.283V30.7a18.873,18.873,0,0,1,18.822-18.812h.426A17.7,17.7,0,0,1,142.9,26.872a13.747,13.747,0,0,0,4.294,8.106c3.869,3.266,4.566,5.136,5.3,9.313.568,3.208,1.777,5.862,6.347,6.749a4.668,4.668,0,0,1-.938,9.242Z",
    transform: "translate(74.364 8.317)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16",
    "data-name": "\\u30D1\\u30B9 16",
    d: "M113.415,9.951V16.81c0,4.543,10.6,4.285,10.6-.569V9.951Z",
    transform: "translate(79.327 6.967)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_17",
    "data-name": "\\u30D1\\u30B9 17",
    d: "M113.415,9.951V16.81c0,4.543,10.6,4.285,10.6-.569V9.951Z",
    transform: "translate(79.327 6.967)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_18",
    "data-name": "\\u30D1\\u30B9 18",
    d: "M124.648,21.562a11.039,11.039,0,1,0-3.742.764",
    transform: "translate(76.634 0.217)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_19",
    "data-name": "\\u30D1\\u30B9 19",
    d: "M124.648,21.562a11.039,11.039,0,1,0-3.742.764",
    transform: "translate(76.634 0.217)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_1",
    "data-name": "\\u7DDA 1",
    x1: 2.034,
    y2: 0.058,
    transform: "translate(188.985 12.298)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20",
    "data-name": "\\u30D1\\u30B9 20",
    d: "M110.72,5.9h0a2.352,2.352,0,1,0,2.42,2.284A2.36,2.36,0,0,0,110.72,5.9Z",
    transform: "translate(75.844 4.14)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21",
    "data-name": "\\u30D1\\u30B9 21",
    d: "M114.686,5.791h0a2.352,2.352,0,1,0,2.42,2.284A2.36,2.36,0,0,0,114.686,5.791Z",
    transform: "translate(78.617 4.061)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_22",
    "data-name": "\\u30D1\\u30B9 22",
    d: "M113.379,10.519l-1.74.049a.717.717,0,0,1-.724-.859l.489-2.435.783-.022",
    transform: "translate(77.569 5.082)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_23",
    "data-name": "\\u30D1\\u30B9 23",
    d: "M113.379,10.519l-1.74.049a.717.717,0,0,1-.724-.859l.489-2.435.783-.022",
    transform: "translate(77.569 5.082)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24",
    "data-name": "\\u30D1\\u30B9 24",
    d: "M119.078,13.562a12.78,12.78,0,0,1-5.664-.083v-.715a11.672,11.672,0,0,0,5.664.8",
    transform: "translate(79.327 8.931)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25",
    "data-name": "\\u30D1\\u30B9 25",
    d: "M119.078,13.562a12.78,12.78,0,0,1-5.664-.083v-.715A11.672,11.672,0,0,0,119.078,13.562Z",
    transform: "translate(79.327 8.931)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_26",
    "data-name": "\\u30D1\\u30B9 26",
    d: "M122.517,40.383c.632,5.779-2.459,10.2-5.155,13.52V47.142Z",
    transform: "translate(82.087 28.217)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_27",
    "data-name": "\\u30D1\\u30B9 27",
    d: "M122.517,40.383c.632,5.779-2.459,10.2-5.155,13.52V47.142Z",
    transform: "translate(82.087 28.217)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28",
    "data-name": "\\u30D1\\u30B9 28",
    d: "M93.778,80.752h0a4.1,4.1,0,0,1,4.1-4.1h5.8V73.266h17.584V84.853H97.882a4.1,4.1,0,0,1-4.1-4.1",
    transform: "translate(65.597 51.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29",
    "data-name": "\\u30D1\\u30B9 29",
    d: "M93.778,80.752h0a4.1,4.1,0,0,1,4.1-4.1h5.8V73.266h17.584V84.853H97.882A4.1,4.1,0,0,1,93.778,80.752Z",
    transform: "translate(65.597 51.178)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_30",
    "data-name": "\\u30D1\\u30B9 30",
    d: "M134.936,40.383H111.011l-8.392,12.735A18.287,18.287,0,0,0,99.6,63.179l0,33.05h17.584V62.121c12.593-10.062,17.748-16.458,17.748-21.738",
    transform: "translate(69.669 28.217)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_31",
    "data-name": "\\u30D1\\u30B9 31",
    d: "M134.936,40.383H111.011l-8.392,12.735A18.287,18.287,0,0,0,99.6,63.179l0,33.05h17.584V62.121C129.78,52.059,134.936,45.663,134.936,40.383Z",
    transform: "translate(69.669 28.217)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_32",
    "data-name": "\\u30D1\\u30B9 32",
    d: "M99.6,73.267h17.584V76.8a1.952,1.952,0,0,0-1.757-1.943Z",
    transform: "translate(69.67 51.179)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_33",
    "data-name": "\\u30D1\\u30B9 33",
    d: "M99.6,73.267h17.584V76.8a1.952,1.952,0,0,0-1.757-1.943Z",
    transform: "translate(69.67 51.179)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_34",
    "data-name": "\\u30D1\\u30B9 34",
    d: "M59.018,80.752h0a4.1,4.1,0,0,0-4.1-4.1h-5.8V73.266H31.535V84.853h23.38a4.1,4.1,0,0,0,4.1-4.1",
    transform: "translate(22.075 51.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_35",
    "data-name": "\\u30D1\\u30B9 35",
    d: "M59.018,80.752h0a4.1,4.1,0,0,0-4.1-4.1h-5.8V73.266H31.535V84.853h23.38A4.1,4.1,0,0,0,59.018,80.752Z",
    transform: "translate(22.075 51.178)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_36",
    "data-name": "\\u30D1\\u30B9 36",
    d: "M41.457,80.752h0a4.1,4.1,0,0,0-4.1-4.1h-5.8V73.266H13.974V84.853h23.38a4.1,4.1,0,0,0,4.1-4.1",
    transform: "translate(9.796 51.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_37",
    "data-name": "\\u30D1\\u30B9 37",
    d: "M41.457,80.752h0a4.1,4.1,0,0,0-4.1-4.1h-5.8V73.266H13.974V84.853h23.38A4.1,4.1,0,0,0,41.457,80.752Z",
    transform: "translate(9.796 51.178)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_38",
    "data-name": "\\u30D1\\u30B9 38",
    d: "M21.09,40.383H45.015l8.392,12.735a18.287,18.287,0,0,1,3.016,10.061l0,33.05H38.838V62.121C26.245,52.059,21.09,45.663,21.09,40.383",
    transform: "translate(14.771 28.217)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_39",
    "data-name": "\\u30D1\\u30B9 39",
    d: "M21.09,40.383H45.015l8.392,12.735a18.287,18.287,0,0,1,3.016,10.061l0,33.05H38.838V62.121C26.245,52.059,21.09,45.663,21.09,40.383Z",
    transform: "translate(14.771 28.217)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_40",
    "data-name": "\\u30D1\\u30B9 40",
    d: "M31.535,73.267H49.119V76.8a1.952,1.952,0,0,0-1.757-1.943Z",
    transform: "translate(22.075 51.179)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_41",
    "data-name": "\\u30D1\\u30B9 41",
    d: "M31.535,73.267H49.119V76.8a1.952,1.952,0,0,0-1.757-1.943Z",
    transform: "translate(22.075 51.179)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_42",
    "data-name": "\\u30D1\\u30B9 42",
    d: "M131.959,90.08h0a4.656,4.656,0,0,1-.41-6.591l3.463-3.9-2.534-2.245,11.667-13.148,9.534,8.4L138.528,89.672a4.666,4.666,0,0,1-6.569.408",
    transform: "translate(91.186 44.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_43",
    "data-name": "\\u30D1\\u30B9 43",
    d: "M131.959,90.08h0a4.656,4.656,0,0,1-.41-6.591l3.463-3.9-2.534-2.245,11.667-13.148,9.534,8.4L138.528,89.672A4.666,4.666,0,0,1,131.959,90.08Z",
    transform: "translate(91.186 44.843)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_44",
    "data-name": "\\u30D1\\u30B9 44",
    d: "M141.576,93.967,121.306,73.3a13.786,13.786,0,0,1-3.944-9.651V40.383h17.585V63.49l18.3,17.329Z",
    transform: "translate(82.087 28.217)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_45",
    "data-name": "\\u30D1\\u30B9 45",
    d: "M141.576,93.967,121.306,73.3a13.786,13.786,0,0,1-3.944-9.651V40.383h17.585V63.49l18.3,17.329Z",
    transform: "translate(82.087 28.217)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_46",
    "data-name": "\\u30D1\\u30B9 46",
    d: "M119.264.288a11,11,0,0,0-8.25,4.086c4.63,3.875,11.847,5.187,11.847,5.187-1.254,5.017-.675,8.992,3.72,10.259A11.02,11.02,0,0,0,119.264.288",
    transform: "translate(77.649 0.216)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_47",
    "data-name": "\\u30D1\\u30B9 47",
    d: "M119.264.288a11,11,0,0,0-8.25,4.086c4.63,3.875,11.847,5.187,11.847,5.187-1.254,5.017-.675,8.992,3.72,10.259A11.02,11.02,0,0,0,119.264.288Z",
    transform: "translate(77.649 0.216)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_48",
    "data-name": "\\u30D1\\u30B9 48",
    d: "M32.257,96.229V40.383H12.973l1.7,55.846Z",
    transform: "translate(9.096 28.216)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_49",
    "data-name": "\\u30D1\\u30B9 49",
    d: "M32.257,96.229V40.383H12.973l1.7,55.846Z",
    transform: "translate(9.096 28.216)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_50",
    "data-name": "\\u30D1\\u30B9 50",
    d: "M50.117,23.822c2.189.321,5.444-1.544,7.2-3.132a1.354,1.354,0,0,1,1.9,1.929l-2.1,2.233L65.94,26a1.259,1.259,0,0,1,1.084,1.427l-.036.245a1.258,1.258,0,0,1-1.325,1.077l-7.83-.494L66.6,29.812a1.26,1.26,0,0,1,1.006,1.523l-.007.025a1.258,1.258,0,0,1-1.346.968L57.4,31.476l8.282,1.712a1.258,1.258,0,0,1,.941,1.625l-.005.017a1.26,1.26,0,0,1-1.358.856l-8.51-1.1,5.509,1.627a1.259,1.259,0,0,1-.641,2.434C58.852,38,51.374,36.291,47.911,35.762Z",
    transform: "translate(33.525 14.221)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_51",
    "data-name": "\\u30D1\\u30B9 51",
    d: "M50.117,23.822c2.189.321,5.444-1.544,7.2-3.132a1.354,1.354,0,0,1,1.9,1.929l-2.1,2.233L65.94,26a1.259,1.259,0,0,1,1.084,1.427l-.036.245a1.258,1.258,0,0,1-1.325,1.077l-7.83-.494L66.6,29.812a1.26,1.26,0,0,1,1.006,1.523l-.007.025a1.258,1.258,0,0,1-1.346.968L57.4,31.476l8.282,1.712a1.258,1.258,0,0,1,.941,1.625l-.005.017a1.26,1.26,0,0,1-1.358.856l-8.51-1.1,5.509,1.627a1.259,1.259,0,0,1-.641,2.434C58.852,38,51.374,36.291,47.911,35.762Z",
    transform: "translate(33.525 14.221)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_52",
    "data-name": "\\u30D1\\u30B9 52",
    d: "M35.709,14.482a25.112,25.112,0,0,0,9.4,8.174c7.191,3.757,21.556,5.256,21.556,5.256l-2.2,11.941C42.549,37.516,29.91,31.976,24.243,22.535",
    transform: "translate(16.976 10.13)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_53",
    "data-name": "\\u30D1\\u30B9 53",
    d: "M35.709,14.482a25.112,25.112,0,0,0,9.4,8.174c7.191,3.757,21.556,5.256,21.556,5.256l-2.2,11.941C42.549,37.516,29.91,31.976,24.243,22.535",
    transform: "translate(16.976 10.13)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_54",
    "data-name": "\\u30D1\\u30B9 54",
    d: "M12.973,31.343V66.109H26.5A52.928,52.928,0,0,0,50.692,60.26V31.343c0-10.73-8.445-19.428-18.86-19.428s-18.86,8.7-18.86,19.428",
    transform: "translate(9.096 8.338)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_55",
    "data-name": "\\u30D1\\u30B9 55",
    d: "M12.973,31.343V66.109H26.5A52.928,52.928,0,0,0,50.692,60.26V31.343c0-10.73-8.445-19.428-18.86-19.428S12.973,20.614,12.973,31.343Z",
    transform: "translate(9.096 8.338)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_56",
    "data-name": "\\u30D1\\u30B9 56",
    d: "M31.776,9.951V16.81c0,4.543-10.6,4.285-10.6-.569V9.951Z",
    transform: "translate(14.831 6.967)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_57",
    "data-name": "\\u30D1\\u30B9 57",
    d: "M31.776,9.951V16.81c0,4.543-10.6,4.285-10.6-.569V9.951Z",
    transform: "translate(14.831 6.967)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_58",
    "data-name": "\\u30D1\\u30B9 58",
    d: "M25.259,21.562A11.039,11.039,0,1,1,29,22.326",
    transform: "translate(12.809 0.217)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_59",
    "data-name": "\\u30D1\\u30B9 59",
    d: "M25.259,21.562A11.039,11.039,0,1,1,29,22.326",
    transform: "translate(12.809 0.217)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_2",
    "data-name": "\\u7DDA 2",
    x2: 2.034,
    y2: 0.058,
    transform: "translate(48.331 12.298)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_60",
    "data-name": "\\u30D1\\u30B9 60",
    d: "M32.046,5.9h0a2.352,2.352,0,1,1-2.42,2.284A2.36,2.36,0,0,1,32.046,5.9Z",
    transform: "translate(20.739 4.14)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_61",
    "data-name": "\\u30D1\\u30B9 61",
    d: "M28.079,5.791h0a2.352,2.352,0,1,1-2.42,2.284A2.36,2.36,0,0,1,28.079,5.791Z",
    transform: "translate(17.966 4.061)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_62",
    "data-name": "\\u30D1\\u30B9 62",
    d: "M28.47,10.519l1.74.049a.717.717,0,0,0,.724-.859l-.489-2.435-.783-.022",
    transform: "translate(19.932 5.082)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_63",
    "data-name": "\\u30D1\\u30B9 63",
    d: "M28.47,10.519l1.74.049a.717.717,0,0,0,.724-.859l-.489-2.435-.783-.022",
    transform: "translate(19.932 5.082)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_64",
    "data-name": "\\u30D1\\u30B9 64",
    d: "M24.082,13.562a12.78,12.78,0,0,0,5.664-.083v-.715a11.672,11.672,0,0,1-5.664.8",
    transform: "translate(16.863 8.931)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_65",
    "data-name": "\\u30D1\\u30B9 65",
    d: "M24.082,13.562a12.78,12.78,0,0,0,5.664-.083v-.715A11.672,11.672,0,0,1,24.082,13.562Z",
    transform: "translate(16.863 8.931)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_66",
    "data-name": "\\u30D1\\u30B9 66",
    d: "M23.287,10.994C23.769,4.924,28.537.115,34.626.288a11,11,0,0,1,8.25,4.086c-4.63,3.875-11.847,5.188-11.847,5.188,1.254,5.017,1.415,9.925-2.979,11.192-8.231,3.267-13.708,10.964-13.708,18.713-6.35-9.006-1.74-14.49.843-16.91s2.443-5.689,4.634-7.279,3.271-1.819,3.468-4.285",
    transform: "translate(7.812 0.216)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_67",
    "data-name": "\\u30D1\\u30B9 67",
    d: "M23.287,10.994C23.769,4.924,28.537.115,34.626.288a11,11,0,0,1,8.25,4.086c-4.63,3.875-11.847,5.188-11.847,5.188,1.254,5.017,1.415,9.925-2.979,11.192-8.231,3.267-13.708,10.964-13.708,18.713-6.35-9.006-1.74-14.49.843-16.91s2.443-5.689,4.634-7.279S23.09,13.46,23.287,10.994Z",
    transform: "translate(7.812 0.216)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_68",
    "data-name": "\\u30D1\\u30B9 68",
    d: "M65.326,25.5c-3.891,3.261-6.863-1.693-9.32-2.147s-5.135-.027-5.135,4.472-4.292,4.2-4.292,0a12.207,12.207,0,0,1,12.211-12.2c8.678,0,10.428,6.618,6.537,9.879",
    transform: "translate(32.593 10.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_69",
    "data-name": "\\u30D1\\u30B9 69",
    d: "M65.326,25.5c-3.891,3.261-6.863-1.693-9.32-2.147s-5.135-.027-5.135,4.472-4.292,4.2-4.292,0a12.207,12.207,0,0,1,12.211-12.2C67.467,15.624,69.217,22.242,65.326,25.5Z",
    transform: "translate(32.593 10.928)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_70",
    "data-name": "\\u30D1\\u30B9 70",
    d: "M104.917,25.5c-3.891,3.261-6.863-1.693-9.32-2.147s-5.135-.027-5.135,4.472-4.292,4.2-4.292,0a12.207,12.207,0,0,1,12.211-12.2c8.678,0,10.428,6.618,6.537,9.879",
    transform: "translate(60.276 10.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_71",
    "data-name": "\\u30D1\\u30B9 71",
    d: "M104.917,25.5c-3.891,3.261-6.863-1.693-9.32-2.147s-5.135-.027-5.135,4.472-4.292,4.2-4.292,0a12.207,12.207,0,0,1,12.211-12.2C107.058,15.624,108.808,22.242,104.917,25.5Z",
    transform: "translate(60.276 10.928)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_72",
    "data-name": "\\u30D1\\u30B9 72",
    d: "M99.646,13.405a15.973,15.973,0,1,0,15.983,15.974A15.978,15.978,0,0,0,99.646,13.405Z",
    transform: "translate(58.524 9.378)",
    fill: "none",
    stroke: "#1a1311",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_73",
    "data-name": "\\u30D1\\u30B9 73",
    d: "M131.422,24.2a8.025,8.025,0,0,1-6.863-3.836,22.788,22.788,0,0,0-37.473-2.16,7.756,7.756,0,0,1-6.114,3.009H75.9v8.9h6.5c-.061.679-.1,1.365-.1,2.06a22.784,22.784,0,0,0,45.51,1.617q.036-.52.048-1.034a1.406,1.406,0,0,1,1.4-1.381h2.168a1.641,1.641,0,0,0,1.641-1.641V25.844a1.64,1.64,0,0,0-1.641-1.641M105.077,48.146A15.973,15.973,0,1,1,121.06,32.172a15.978,15.978,0,0,1-15.983,15.974",
    transform: "translate(53.093 6.584)",
    fill: "#393737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_74",
    "data-name": "\\u30D1\\u30B9 74",
    d: "M131.422,24.2a8.025,8.025,0,0,1-6.863-3.836,22.788,22.788,0,0,0-37.473-2.16,7.756,7.756,0,0,1-6.114,3.009H75.9v8.9h6.5c-.061.679-.1,1.365-.1,2.06a22.784,22.784,0,0,0,45.51,1.617q.036-.52.048-1.034a1.406,1.406,0,0,1,1.4-1.381h2.168a1.641,1.641,0,0,0,1.641-1.641V25.844A1.64,1.64,0,0,0,131.422,24.2ZM105.077,48.146A15.973,15.973,0,1,1,121.06,32.172,15.978,15.978,0,0,1,105.077,48.146Z",
    transform: "translate(53.093 6.584)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_75",
    "data-name": "\\u30D1\\u30B9 75",
    d: "M89.39,21.216a7.674,7.674,0,0,1-6.075-2.96A22.764,22.764,0,0,0,45.866,20.3a8.019,8.019,0,0,1-6.8,3.9h-.136a1.642,1.642,0,0,0-1.641,1.641v3.889a1.643,1.643,0,0,0,1.641,1.641h2.189a1.4,1.4,0,0,1,1.4,1.357,22.779,22.779,0,0,0,45.551-.559c0-.695-.037-1.381-.1-2.06H92.63a6.261,6.261,0,0,0,0-8.9ZM65.284,48.146A15.973,15.973,0,1,1,81.267,32.172,15.978,15.978,0,0,1,65.284,48.146",
    transform: "translate(26.097 6.584)",
    fill: "#393737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_76",
    "data-name": "\\u30D1\\u30B9 76",
    d: "M89.39,21.216a7.674,7.674,0,0,1-6.075-2.96A22.764,22.764,0,0,0,45.866,20.3a8.019,8.019,0,0,1-6.8,3.9h-.136a1.642,1.642,0,0,0-1.641,1.641v3.889a1.643,1.643,0,0,0,1.641,1.641h2.189a1.4,1.4,0,0,1,1.4,1.357,22.779,22.779,0,0,0,45.551-.559c0-.695-.037-1.381-.1-2.06H92.63a6.261,6.261,0,0,0,0-8.9ZM65.284,48.146A15.973,15.973,0,1,1,81.267,32.172,15.978,15.978,0,0,1,65.284,48.146Z",
    transform: "translate(26.097 6.584)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_77",
    "data-name": "\\u30D1\\u30B9 77",
    d: "M106.2,28.638c-2.189.321-5.444-1.544-7.2-3.132a1.354,1.354,0,0,0-1.9,1.929l2.1,2.233-8.822,1.148a1.259,1.259,0,0,0-1.084,1.427l.036.245a1.258,1.258,0,0,0,1.325,1.077l7.83-.494-8.771,1.557a1.26,1.26,0,0,0-1.006,1.523l.007.025a1.258,1.258,0,0,0,1.346.968l8.858-.853L90.637,38a1.258,1.258,0,0,0-.941,1.625l.005.017a1.26,1.26,0,0,0,1.358.856l8.51-1.1-5.509,1.627a1.259,1.259,0,0,0,.641,2.434c2.766-.645,10.245-2.359,13.708-2.887Z",
    transform: "translate(62.029 17.584)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_78",
    "data-name": "\\u30D1\\u30B9 78",
    d: "M106.2,28.638c-2.189.321-5.444-1.544-7.2-3.132a1.354,1.354,0,0,0-1.9,1.929l2.1,2.233-8.822,1.148a1.259,1.259,0,0,0-1.084,1.427l.036.245a1.258,1.258,0,0,0,1.325,1.077l7.83-.494-8.771,1.557a1.26,1.26,0,0,0-1.006,1.523l.007.025a1.258,1.258,0,0,0,1.346.968l8.858-.853L90.637,38a1.258,1.258,0,0,0-.941,1.625l.005.017a1.26,1.26,0,0,0,1.358.856l8.51-1.1-5.509,1.627a1.259,1.259,0,0,0,.641,2.434c2.766-.645,10.245-2.359,13.708-2.887Z",
    transform: "translate(62.029 17.584)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_79",
    "data-name": "\\u30D1\\u30B9 79",
    d: "M131.681,17.826A32.667,32.667,0,0,1,120.546,28.5c-7.016,4.117-21.556,5.256-21.556,5.256L101.2,45.7c21.913-2.337,34.55-7.877,40.217-17.317",
    transform: "translate(69.241 12.466)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_80",
    "data-name": "\\u30D1\\u30B9 80",
    d: "M131.681,17.826A32.667,32.667,0,0,1,120.546,28.5c-7.016,4.117-21.556,5.256-21.556,5.256L101.2,45.7c21.913-2.337,34.55-7.877,40.217-17.317",
    transform: "translate(69.241 12.466)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_81",
    "data-name": "\\u30D1\\u30B9 81",
    d: "M42.12,27.166c2.189.321,5.444-1.544,7.2-3.132a1.354,1.354,0,0,1,1.9,1.929L49.12,28.2l8.822,1.148a1.259,1.259,0,0,1,1.084,1.427l-.036.245a1.258,1.258,0,0,1-1.325,1.077l-7.83-.494,8.771,1.557a1.26,1.26,0,0,1,1.006,1.523l-.007.025a1.258,1.258,0,0,1-1.346.968L49.4,34.82l8.282,1.712a1.258,1.258,0,0,1,.941,1.625l-.005.017a1.26,1.26,0,0,1-1.358.856l-8.51-1.1,5.509,1.627a1.259,1.259,0,0,1-.641,2.434c-2.766-.645-10.245-2.359-13.708-2.887Z",
    transform: "translate(27.934 16.556)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_82",
    "data-name": "\\u30D1\\u30B9 82",
    d: "M42.12,27.166c2.189.321,5.444-1.544,7.2-3.132a1.354,1.354,0,0,1,1.9,1.929L49.12,28.2l8.822,1.148a1.259,1.259,0,0,1,1.084,1.427l-.036.245a1.258,1.258,0,0,1-1.325,1.077l-7.83-.494,8.771,1.557a1.26,1.26,0,0,1,1.006,1.523l-.007.025a1.258,1.258,0,0,1-1.346.968L49.4,34.82l8.282,1.712a1.258,1.258,0,0,1,.941,1.625l-.005.017a1.26,1.26,0,0,1-1.358.856l-8.51-1.1,5.509,1.627a1.259,1.259,0,0,1-.641,2.434c-2.766-.645-10.245-2.359-13.708-2.887Z",
    transform: "translate(27.934 16.556)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_83",
    "data-name": "\\u30D1\\u30B9 83",
    d: "M27.712,17.826A25.112,25.112,0,0,0,37.113,26c7.191,3.757,21.556,5.256,21.556,5.256L56.465,43.2C34.552,40.86,21.913,35.32,16.246,25.879",
    transform: "translate(11.384 12.466)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_84",
    "data-name": "\\u30D1\\u30B9 84",
    d: "M27.712,17.826A25.112,25.112,0,0,0,37.113,26c7.191,3.757,21.556,5.256,21.556,5.256L56.465,43.2C34.552,40.86,21.913,35.32,16.246,25.879",
    transform: "translate(11.384 12.466)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_85",
    "data-name": "\\u30D1\\u30B9 85",
    d: "M74.5,20.808c0,2.456,1.031,4.448,2.306,4.448s2.3-1.992,2.3-4.448-1.031-4.448-2.3-4.448S74.5,18.352,74.5,20.808",
    transform: "translate(52.119 11.442)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_86",
    "data-name": "\\u30D1\\u30B9 86",
    d: "M74.5,20.808c0,2.456,1.031,4.448,2.306,4.448s2.3-1.992,2.3-4.448-1.031-4.448-2.3-4.448S74.5,18.352,74.5,20.808Z",
    transform: "translate(52.119 11.442)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_87",
    "data-name": "\\u30D1\\u30B9 87",
    d: "M106.316,40.383h18.77v2.009Z",
    transform: "translate(74.364 28.216)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_88",
    "data-name": "\\u30D1\\u30B9 88",
    d: "M106.316,40.383h18.77v2.009Z",
    transform: "translate(74.364 28.216)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestCompleteModalImage);
export default __webpack_public_path__ + "static/media/request-complete-modal__image.8d1b448a81bcff3ea7c6d067536b4d10.svg";
export { ForwardRef as ReactComponent };